"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Secp256k1KeyParser = void 0;
const key_encoder_1 = __importDefault(require("key-encoder"));
const base_key_parser_1 = require("./base-key-parser");
const cryptography_1 = require("../../../cryptography");
const utils_1 = require("../../../utils");
const keyEncoder = new key_encoder_1.default('secp256k1');
/**
 * Specific implementation of Secp256k1 to parse keys
 */
class Secp256k1KeyParser extends base_key_parser_1.BaseKeyParser {
    constructor() {
        super(cryptography_1.EncryptionType.Secp256k1);
    }
    parsePrivateKey(data) {
        return this.parseKey(data);
    }
    parseKey(data) {
        // Convert digital certificate format to raw format
        const key = keyEncoder.encodePrivate(utils_1.TypeUtils.convertArrayToHexString(data), 'der', 'raw');
        return utils_1.TypeUtils.convertHexStringToArray(key);
    }
}
exports.Secp256k1KeyParser = Secp256k1KeyParser;
